module.exports = __webpack_public_path__ + "img/arrow-circle-up-p.a45d4047.svg";